export default __webpack_public_path__ + "static/media/threedots.c046c6b1.svg";